import script from "./UiIconBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiIconBtn.vue?vue&type=script&setup=true&lang=ts"

import "./UiIconBtn.vue?vue&type=style&index=0&id=5f1e4a4d&lang=css"

const __exports__ = script;

export default __exports__